import React, {Component} from 'react';
import {translate} from 'react-i18next';
import FormCentrifuge from './components/FormCentrifuge';
import RaisedButton from 'material-ui/RaisedButton';
import Notifications, {notify} from 'react-notify-toast';
import swal from 'sweetalert';
import WaitingModal from '../../generics/WaitingModal';
import moment from 'moment';
import Help from '../../generics/help';

var Config = require('../../../config');

class Centrifuge extends Component{
	constructor(props){
		super(props);

		this.onSave = this.onSave.bind(this);
		this.onReturn = this.onReturn.bind(this);
	}

	componentDidMount(){
		this.props.waiting.handleShow('Cargando...');
		setTimeout(()=>{
			this.props.waiting.handleClose();
		}, 300)
	}

	onSave(){
		if (this.isValidDate(this.form.state.date_form)){
			if(this.isValidForm()){			
				var parts = this.form.getCentrifugeData();

				if(parts.centrifuge_parts.length === 0){
					notify.show('Error, Tabla incompleta','error');
				}else if(parts.hour === "Invalid date"){
					notify.show("Error, Hora invalida", 'error');
				}else{
					parts.health_facilities_id = sessionStorage.getItem('health_facilities_id');
					
					this.waiting_modal.handleShow('Guardando...');

					fetch(Config.default.apiGateway.URL+'centrifuge_program', {
						method : 'post',
						body: JSON.stringify(parts),
						headers : new Headers({
							'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
							'Accept'		: 'application/json',
							'Content-Type'	: 'application/json'
						})
					})
					.then(res => {
			          	this.waiting_modal.handleClose();

			            if(res.ok){
			              return res.json();
			            }else{
			              res.text().then(function(result) {
			                swal('¡Error', result, 'error');
			              });
			            }})
					.then(response => {
						if(response !== undefined){

							if(response.Message !== undefined){
								swal('Error', response.ExceptionMessage, 'error');
							}else{
								swal('¡Buen Trabajo!', "Proceso Terminado", 'success');
								this.form.setState({
									program_id:"",
									speed:"",
									temperature:"",
									time:"",
									speed_aceleration:"",
									speed_desaceleration:"",
									centrifuges:[],
									donations:[],
									all_check:false,
									equipment_id:"",
								})
							}
								
						}
					})
					
				}
			}else{
				swal('¡Error!', "Campos incompletos", 'error');
			}
		}else {
			notify.show('Error, Fecha no válida','error');	    	
        }
	}

	isValidDate(fecha){
		var valid = moment(fecha).format('MM-DD-YYYY');

		if(valid === 'Invalid date'){
			return false;
		}else{
			return true;
		}
	}

	isValidForm() {
		const inputs = document.querySelectorAll('select,input');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
	    		
		      	const isInputValid = this.form.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}		   
		  	}
	    });
	    
	    return isFormValid;
	}

	onReturn(){
		this.props.history.push('/');
	}

	render(){
		const {t} = this.props;
		return (
			<div className="col-xs-12">
				<div className="route">
					 <h5 className="title_page" >
					  {sessionStorage.getItem('health_facilities_name')} ->
		              {t('sidebar.nav.home.MAIN')} -> 
		              {t('sidebar.nav.process.MAIN')} ->
		              {t('sidebar.nav.process.centrifuge.MAIN')}
		            </h5>
				</div>

				<Help 
					{...this.props}
	                menu={"help_processed"} 
	                submenu={"help_centrifuge"}  />
	                
				<form noValidate>
					<FormCentrifuge {...this.props} onRef={ref => (this.form = ref)} />
					<Notifications />
				</form>

				<div className="col-xs-12" style={{textAlign:'center'}}>
		        	<div>
		        		<RaisedButton className="action-btn" label={t('content.generics.buttons.save')} primary={true} onClick={this.onSave} style={{margin:12}}/>
		        		<RaisedButton className="action-btn" label={t('content.generics.buttons.return')} primary={true} style={{margin:12}} onClick={this.onReturn}/>
		        	</div>
		        </div>

		        <WaitingModal {...this.props} onRef={ref => (this.waiting_modal = ref)}/>
			</div>
		)
	}
}

export default translate('translations')(Centrifuge);